import React, { Component, Fragment } from 'react';
import { Table,Image } from "semantic-ui-react";
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, Radio} from "semantic-ui-react"
import { Link } from "react-router-dom"
import shop from "shop/shop"
import {Row, Col, FormField, FormInput} from "elemental-react16"
import _ from "lodash"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import moment                               from "moment"
import Spinner                              from "components/Spinner/Spinner"
import SuccessTable                         from "components/Product/SuccessTableReturn"
import Responsive from "react-responsive"
import { data } from 'isotope-layout';

class ReturnPage extends Component {
    state = {
        returnActive: false,
        inventory: false,
        inventoryOrder: [],
        inventoryOrders: {},
        byId: {},
        loading: true,
        loadingSeason: false,
        showContact: false,
        loadingDelivery: false,
        notFoundPositions: [],
        newSeason: {
            season: {
                seasonActive: false,
                referenceNumber: "",
                email: "",
                start: "",
                end: "",
                name: ""
            },
            seasons: {}
        }
    };

    async componentDidMount() {
        if (!shop.session) {
            console.log("!shop.session");
            this.props.history.push("/login");
        }
        await this.handleLoadInventory();
        await this.handleFetchDate();
        // await this.handleLoadDelivery();
        await this.handleCheckForSeasonReturn();
        
        // Trigger handleChangeRadio with the default season name
        const defaultSeasonName = this.state.newSeason.season.name;
        if (defaultSeasonName) {
            await this.handleChangeRadio(defaultSeasonName);
        }
        this.handleCalculateDelivery();
    }

    handleCheckForSeasonReturn = async () => {
        const { inventoryOrders, newSeason } = this.state;
        const seasonNames = Object.keys(newSeason.seasons);
        const inventoryNames = Object.keys(inventoryOrders);
        console.log("SEASON NAMES", seasonNames, inventoryNames);
        const matchingOrders = seasonNames.filter(seasonName => 
            inventoryOrders.hasOwnProperty(seasonName)
        );

        if (matchingOrders.length > 0) {
            console.log("Match:", matchingOrders);
            matchingOrders.forEach(seasonName => {
            newSeason.seasons[seasonName].returnActive = true;
            });
        } else {
            console.log("Kein Match:", seasonNames);
        }

        this.setState({ newSeason });
        console.log("NEW SEASON", this.state.newSeason);
    }

    handleLoadInventory = async () => {
        try{
            //shop/rest/data/inventories?start=0&count=50
            const response = await shop.fetch( `/shop/rest/data/inventories?start=0&count=50`, {
                method: "GET",
                credentials:"include",
            });
            console.log(response);
            if(response.size >= 1){
                this.setState({inventory: true})
                this.setState({inventoryOrder: response.values[0]})
                response.values.forEach((value, index) => {
                    const seasonName = value.extras.seasonName;
                    const orderKey = `${seasonName}_${index}`;
                    this.setState(prevState => ({
                        inventoryOrders: {
                            ...prevState.inventoryOrders,
                            [orderKey]: value
                        }
                    }));
                });



                console.log("RETOURE BEREITS GETÄTIGT", this.state.inventoryOrder, this.state.inventoryOrders)
            }
            this.setState({loading: false})
        }
        catch (error) {
            console.error(error);
        }
    }

    handleCalculateDelivery = async () => {
        const { inventoryOrders, newSeason } = this.state;
        const seasonNames = Object.keys(newSeason.seasons);

        // Initialize a counter for each season
        const seasonPackageCounts = seasonNames.reduce((acc, seasonName) => {
            acc[seasonName] = 0;
            return acc;
        }, {});

        // Calculate the total packages for each season
        Object.keys(inventoryOrders).forEach(orderKey => {
            const seasonName = orderKey.split('_')[0];
            if (seasonNames.includes(seasonName)) {
            seasonPackageCounts[seasonName] += Number(inventoryOrders[orderKey].extras.kartons_all) ;
            inventoryOrders[orderKey].extras.totalPackages = seasonPackageCounts[seasonName];
            }
        });
        console.log("SEASON PACKAGE COUNTS", this.state.inventoryOrders);
        this.setState({ inventoryOrders });
    }

      handleFetchDate = async () => {
        console.log("DATA handleFetchDate")
        try {
        const response = await shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.saison","web.kv.start","web.kv.end", "web.kv.id"])), {
            method: 'GET',
            credentials: 'include'
        });
        console.log("DATA: ", response);
        const data = await response
        const startDates = data["web.kv.start"].split(",");
        const endDates = data["web.kv.end"].split(",");
        const seasonIds = data["web.kv.id"].split(",");
        const names = decodeURIComponent(data["web.kv.saison"]).split(",");
        const today = new Date();
        const seasons = {};
        for (let i = 0; i < names.length; i++) {
            if (startDates[i] !== "" && endDates[i] !== "" && names[i] !== "") {
                const startDate = moment(startDates[i], "DD.MM.YYYY").toDate();
                const endDate = moment(endDates[i], "DD.MM.YYYY").toDate();
                if (today >= startDate && today <= moment(endDate).add(1, 'days').toDate()) {
                    this.setState({seasonActive: true})
                    seasons[names[i]] = {
                        start: startDates[i],
                        end: endDates[i],
                        name: names[i],
                        id: seasonIds[i],
                        seasonActive: true,
                        returnActive: false
                            };
                }
                else{
                    seasons[names[i]] = {
                        start: startDates[i],
                        end: endDates[i],
                        name: names[i],
                        id: seasonIds[i],
                        seasonActive: false,
                        returnActive: false
                        };
                }

            }
        }
        this.setState({
            newSeason: {
            season: {
            start: startDates[0],
            end: endDates[0],
            name: names[0],
            id: seasonIds[0]
            },
            seasons: seasons
            }
        });
        await shop.cart.setExtra("seasonName", names[0])
        await shop.cart.setExtra("seasonID", seasonIds[0])
        console.log("DATA POST: ", this.state.newSeason);
        this.setState({loading: false})
        } catch (error) {
        console.error('Error fetching date:', error);
        }
    }

    loadProduct( id,deliveryCount ) {
		if ( this.id === id ) return
		this.id = id
		productStore.get( id )
			.then( product => {
                //console.log("product RETURN",product)
                if(!product){
                    return false
                }
				product.count = 1
				let inCart = shop.cart.productsById.get( product.map_id )
                product.deliveryCount = deliveryCount
                product.extras.deliveryCount = deliveryCount
                product.extras.trueReturnValue = product.extras.trueReturnValue || false
                shop.cart.add( product )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				// lastProducts = shop.analytics.lastProducts( 4 )
				//   .filter( ( id ) => id !== product.map_id )
				this.setState( {product: product, primaryImage: false} )

				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						//console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}

    handleChangeRadio = async (value) => {
        console.log("VALUE", value);
        this.setState({ loadingSeason: true });
        this.setState({ newSeason: { ...this.state.newSeason, season: this.state.newSeason.seasons[value] } }, () => {
            console.log("VALUE", this.state.newSeason);
        });
        this.setState({ seasonActive: this.state.newSeason.seasons[value].seasonActive });
        await shop.cart.setExtra("seasonName", this.state.newSeason.seasons[value].name);
        await shop.cart.setExtra("seasonID", this.state.newSeason.seasons[value].id)
        const activeSeason = this.state.newSeason.season.name;
        const lastOrderKey = Object.keys(this.state.inventoryOrders)
            .filter(key => key.startsWith(activeSeason))
            .pop();

        if (lastOrderKey) {
            await shop.cart.setExtra("pdfStart", this.state.inventoryOrders[lastOrderKey].extras.totalPackages);
        }
        console.log("SET EXTRA", shop.cart);

        const seasonOrders = Object.keys(this.state.inventoryOrders)
            .filter(key => key.startsWith(activeSeason));

        let totalKartons = 0;
        seasonOrders.forEach(orderKey => {
            totalKartons += Number(this.state.inventoryOrders[orderKey].extras.kartons_all);
        });
        console.log("TOTAL KARTONS", totalKartons);
        await shop.cart.setExtra("totalKartons", totalKartons);
        await new Promise(resolve => setTimeout(resolve, 500));
        this.setState({ loadingSeason: false });
        return this.state.newSeason;
    }



    handleCreatePDF = (id) => {
        //console.log("GENERATE PDF", shop.config.API, id);
        shop.toast("Ihre PDF wird generiert.");
        
        console.log("CREATE PDF", id, this.state.newSeason);
          fetch(`${shop.config.API}reports/create?template=PaketBarcodes`, {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({
              customer: id.customerid,
              count: id.extras.kartons_all,
              address: shop.session.value, 
              season: this.state.newSeason.season.name,
              seasonID: this.state.newSeason.season.id,
              totalPackages: id.extras.totalKartons,
              orderDate: id.register,
            })
          })
          .then(response => {
            response.json().then(data => {
              //console.log("RESPONSE DATA: ", data);
              const rid = data.rid;
              fetch(`${shop.config.API}reports/load/pakete.pdf?rid=${rid}`, {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/pdf"
                }
              })
              .then(responsePDF => responsePDF.blob())
              .then(blob => {
                //console.log("BLOB: ", blob);
                const url = URL.createObjectURL(blob);
                //console.log("URL: ", url);
                window.open(url, "_blank");
              })
              .catch(error => {
                shop.toast("Fehler beim anzeigen der PDF.");
                // Handle the error
              });
            }).catch(error => {
              shop.toast("Fehler beim Verarbeiten der Antwort.");
              // Handle the error
            });
          })
          .catch(error => {
            shop.toast("Fehler beim generieren der PDF.");
            // Handle the error
          });
    }

    render() {
        const { loadingSeason } = this.state;
        //console.log("DATA this.state",this.state.loading)
        if(this.state.loading){
            return (
                <div className="pa4 tc">
                    <Spinner size="md" type="inverted"/>
                </div>
            )
        }

        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
            document.location.reload()
            return null
        }
        let { product, categoryId = "" } = this.props

        //Only Single Return
        /*if(this.state.inventory || !this.state.seasonActive){
            let order = this.state.inventoryOrder
            let byId = {}
            console.log("INVENTORY", this.state.inventory,"INVENTORY ORDER",this.state.inventoryOrder)
            
            return (
                <Fragment>
                    
                    <Responsive minWidth={790} >

                    <section>
						<Row>
							<Col className="tc pb4"
								 style={{marginTop: "71px"}}>
								<a className={"logo"} href="">
									<img
										src={shop.config.logo}
										alt="" />
								</a>
							</Col>
						</Row>
					</section>
                <section className="container pb4" style={{width:"45%"}}>
                    <div>
                    {this.state.inventory && <Message className="f2 fw7">
                    {translate( "Ihre Retourenerfassung ist bei uns eingegangen und wird schnellsmöglich bearbeitet. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst")}
                            </Message>}
                    {!this.state.seasonActive && <Message className="f2 fw7">
                    {translate( `Momentan ist keine Retoure möglich. Bitte wenden Sie sich an Ihren Ansprechpartner.`)}
                            </Message>}
					<Table className="pl4 pr4">
					<colgroup>
					</colgroup>
					<thead>
					</thead>
					<tbody>
                        <tr>
                        <h1 style={{color:"#265a88"}}  className="pt4 tl"><b>{translate("Paketanmeldung Online (gilt nur für Pappdisplays) ")}</b></h1><br/>

                            <p className="pb2">Sie sind angemeldet als: </p>
                        </tr>
                        <tr>
                            <td>
                                <Table className="TableCustData">
                                    <colgroup>
                                        <col width="50%" />
                                        <col width="25%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{fontSize:15}}><b>GLN / ILN:</b>
                                            </td> 
                                            <td>{shop.session.value.map_id}
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
                                            </td> 
                                            <td><strong>{shop.session.value.title}</strong><br/>
                                                {shop.session.value.street}<br/>
                                                {shop.session.value.pcode + " " + shop.session.value.city}<br/>
                                                {shop.session.value.country}
                                            </td> 
                                        </tr>
                                        <tr>
                                        </tr>
                                    </tbody>
                                </Table>
                                </td>
                        </tr>
                        <tr>
                            <br/>
                        </tr>
                        <tr>
                            <td>
                            <Link to={{
                                pathname: `/logout`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                >
                                {translate( "Zurück zur Anmeldung" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                            </td>
                            <td>
                                {this.state.inventory && <Button primary onClick={()=> (this.handleCreatePDF(this.state.inventoryOrder))}>PDF erzeugen</Button>}
                            </td>
                        </tr>
                    </tbody>
                    </Table>
                    </div>
                    {this.state.showContact && <div className="tl pt3" >
					</div>}
                </section>

                    </Responsive>
                    <Responsive maxWidth={789}>
                    <section>
						<Row>
							<Col className="tc pb2 pt1"
								 >
								<a className={"logo"} href="">
									<img
										src={shop.config.logo}
										alt="" />
								</a>
							</Col>
						</Row>
					</section>
                <div className="pa3">
                {this.state.inventory && <Message className="f2 fw7">
                    {translate( "Ihre Retourenerfassung ist bei uns eingegangen und wird schnellstmöglich bearbeitet. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst")}
                            </Message>}
                    {!this.state.seasonActive && <Message className="f2 fw7">
                    {translate( `Momentan ist keine Retoure möglich. Bitte wenden Sie sich an Ihren Ansprechpartner.`)}
                            </Message>}
                    <table className="pl3 pr3" >
                        <colgroup>
                        <col width="100%" />
                        </colgroup>
                        <tbody>
                            <tr className="tc bb b--black-20 bt">
                                <td>
                                    <h1 style={{color:"#265a88"}}  className="pt4 tc"><b>{translate("Paketanmeldung Online (gilt nur für Pappdisplays) ")}</b></h1><br/>
                                    
                                    <p className="tc pb2">Sie sind angemeldet als: </p>

                                </td>
                            </tr>
                            <tr className="pa2 bb b--black-20">
                                
                                <td>
                                    <table>
                                    <colgroup>
                                        <col width="25%" />
                                        <col width="75%" />
                                    </colgroup>
                                    <tbody>
                                        <tr className="bb b--black-10">
                                            <td style={{fontSize:15}}><b>GLN / ILN:</b>
                                            </td> 
                                            <td>{shop.session.value.map_id}
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
                                            </td> 
                                            <td><strong>{shop.session.value.title}</strong><br/>
                                                {shop.session.value.street}<br/>
                                                {shop.session.value.pcode + " " + shop.session.value.city}<br/>
                                                {shop.session.value.country}
                                            </td> 
                                        </tr>
                                        <tr>
                                        </tr>
                                    </tbody>
                                    </table>
                                    
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                            <td>
                                <div className="pb2 tc">
                                </div>
                            </td>
                        </tr>
                        </tbody>

                    </table>
                    <table>
                        <colgroup>
                            <col width="50%" />
                            <col width="50%" />
                        </colgroup>
                        <tbody>
                            <tr className="tc">
                                <td className="tc">
                                    <Link to={{
                                        pathname: `/logout`,
                                        search  : this.props.location.search
                                    }}>
                                        <Button style={{maxWidth:"150px", minWidth:"150px"}}
                                        >
                                        {translate( "Zurück zur Anmeldung" )}
                                        <i className="icon-angle-right"/>
                                        </Button>
                                    </Link>
                                </td>
                                <td className="tc">
                                <Button primary onClick={()=> (this.handleCreatePDF(this.state.inventoryOrder))}>PDF erzeugen</Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                    </Responsive>
                </Fragment>
            )
        }*/

        return (
            <Fragment>
            
            <Responsive minWidth={790} >
            <section>
            <Row>
            <Col className="tc pb4"
             style={{marginTop: "71px"}}>
            <a className={"logo"} href="">
            <img
                src={shop.config.logo}
                alt="" />
            </a>
            </Col>
            </Row>
            </section>
            <section className="container pb4" style={{width:"45%"}}>
            {this.state.newSeason.season.returnActive && <Message className="f2 fw7">
            {translate( "Ihre Retourenerfassung ist bei uns eingegangen und wird schnellstmöglich bearbeitet. Bei Änderungen / Fragestellungen melden Sie sich bitte bei der Ihnen bekannten Kontaktperson im Vertriebsinnendienst")}
            </Message>}
            {!this.state.seasonActive && <Message className="f2 fw7">
            {translate( `Momentan ist keine Retoure möglich. Bitte wenden Sie sich an Ihren Ansprechpartner oder wählen Sie eine andere Saison.`)}
            </Message>}
            <div>
            
            <Table className="pl4 pr3">
            <colgroup>
            </colgroup>
            <thead>
            </thead>
            <tbody>
            <tr>
            <h1 style={{color:"#265a88"}}  className="pt4 tl"><b>{translate("Paketanmeldung Online (gilt nur für Pappdisplays) ")}</b></h1><br/>
            <p className=""><b>Herzlich willkommen bei der Deco-Retoure der Brauns-Heitmann GmbH.</b></p>
            <p className="pb2">Sie sind angemeldet als: </p>
            </tr>
            <tr>
            <td>
            <Table className="TableCustData">
            <colgroup>
            <col width="50%" />
            <col width="25%" />
            </colgroup>
            <thead>
            <tr>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td style={{fontSize:15}}><b>GLN / ILN:</b>
            </td> 
            <td>{shop.session.value.map_id}
            </td> 
            </tr>
            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
            </td> 
            <td><strong>{shop.session.value.title}</strong><br/>
            {shop.session.value.street}<br/>
            {shop.session.value.pcode + " " + shop.session.value.city}<br/>
            {shop.session.value.country}
            </td> 
            </tr>

            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Saisonauswahl:</b><br/><br/><br/>
            </td> 
            <td style={{fontSize:18, fontWeight: "bold"}}>
            <Form>
            {Object.keys(this.state.newSeason.seasons).map((seasonKey) => (
            <div key={seasonKey}>
            <FormField>
            <Radio
            id={seasonKey} 
            name="season" 
            label={seasonKey} 
            checked={this.state.newSeason.season.name === seasonKey}
            onChange={() => this.handleChangeRadio(seasonKey)}
            />
            </FormField>
            
            </div>
            ))}
            </Form>

            
            </td> 
            </tr>
            <tr>
            </tr>
            </tbody>
            </Table>
            </td>
            </tr>
            <tr>
            <br/>
            </tr>
            <tr>
            <td>
            <Link to={{
            pathname: `/logout`,
            search  : this.props.location.search
            }}>
            <Button>
            {translate( "Zurück zur Anmeldung" )}
            <i className="icon-angle-right"/>
            </Button>
            </Link>
            {console.log("SEASON ACTIVE",this.state.seasonActive, "NEW SEASON", this.state.newSeason.season.returnActive)}
            
            {(this.state.seasonActive && !this.state.newSeason.season.returnActive) && <Link to={{
            pathname: `/return/quantity`,
            search  : this.props.location.search
            }}>
            <Button className="fr" style={{width:"200px"}} disabled={loadingSeason}
            primary onClick={async () => {
                const checkSeasonName = await shop.cart.getExtra("seasonName")
                if(checkSeasonName == ""){
                    console.log("CHECK SEASON NAME", checkSeasonName)
                    await shop.cart.setExtra("seasonName", this.state.newSeason.season.name)
                    await shop.cart.setExtra("seasonID", this.state.newSeason.season.id)
                }
            }} >{translate( "Zur Paketanmeldung" )}
            </Button>
            </Link>}
            </td>
            </tr>
            </tbody>
            </Table>
            </div>
            
            <div className="pt3">
            {<Message className="f2 fw7">
            {translate( `Hier können Sie Ihre bereits getätigten Retouren einsehen und noch einmal als PDF anzeigen lassen.`)}
            </Message>}
            {Object.keys(this.state.inventoryOrders).some(key => key.startsWith(this.state.newSeason.season.name)) && <Table>
                    <thead>
                    <tr>
                        <th>Retourennummer</th>
                        <th>Saison</th>
                        <th>Packstückmenge</th>
                        <th>Barcode</th>
                    </tr>
                    </thead>
                    <tbody>
            {console.log("INVENTORY ORDER",this.state.inventoryOrders)}
            {Object.keys(this.state.inventoryOrders).filter(key => key.startsWith(this.state.newSeason.season.name)).map(key => (
               <tr key={key} className="pa3">
                {console.log("INVENTORY ORDER",this.state.inventoryOrders[key])}

                   
                        <td>{this.state.inventoryOrders[key].map_id}</td>
                        <td>{this.state.inventoryOrders[key].extras.seasonName}</td>
                        <td className="tr">{this.state.inventoryOrders[key].extras.kartons_all}</td>
                        <td>{ <Button className="pb2" basic onClick={()=> (this.handleCreatePDF(this.state.inventoryOrders[key]))}>PDF anzeigen</Button>}</td>
                    </tr>
            ))}
            </tbody>
            </Table>}
            </div>

            </section>
            </Responsive>
            <Responsive maxWidth={789} >
            <section>
            <Row>
            <Col className="tc pb2 pt1">
            <a className={"logo"} href="">
            <img
                src={shop.config.logo}
                alt="" />
            </a>
            </Col>
            </Row>
            </section>
            {!this.state.seasonActive && <Message className="f2 fw7">
            {translate( `Momentan ist keine Retoure möglich. Bitte wenden Sie sich an Ihren Ansprechpartner oder wählen Sie eine andere Saison.`)}
            </Message>}
            <div className="pa3">
            <table className="pl3 pr3">
            <colgroup>
            <col width="100%" />
            </colgroup>
            <tbody>
            <tr className="tc bb b--black-20 bt">
            <td>
            <h1 style={{color:"#265a88"}}  className="pt4 tc"><b>{translate("Paketanmeldung Online (gilt nur für Pappdisplays) ")}</b></h1><br/>
            <p className="tc"><b>Herzlich willkommen bei der Deco-Retoure der Brauns-Heitmann GmbH.</b></p>
            <p className="tc pb2">Sie sind angemeldet als: </p>

            </td>
            </tr>
            <tr className="pa2 bb b--black-20">
            
            <td>
            <table>
            <colgroup>
            <col width="25%" />
            <col width="75%" />
            </colgroup>
            <tbody>
            <tr className="bb b--black-10">
            <td style={{fontSize:15}}><b>GLN / ILN:</b>
            </td> 
            <td>{shop.session.value.map_id}
            </td> 
            </tr>
            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
            </td> 
            <td><strong>{shop.session.value.title}</strong><br/>
            {shop.session.value.street}<br/>
            {shop.session.value.pcode + " " + shop.session.value.city}<br/>
            {shop.session.value.country}
            </td> 
            </tr>
            <tr>
            <td style={{fontSize:15, alignContent:"top"}}><b >Saisonauswahl:</b><br/><br/><br/>
            </td> 
            <td style={{fontSize:15, fontWeight: "bold"}}>
            <Form>
            {Object.keys(this.state.newSeason.seasons).map((seasonKey) => (
            <div key={seasonKey}>
            <FormField>
            <Radio
            id={seasonKey} 
            name="season" 
            label={seasonKey} 
            checked={this.state.newSeason.season.name === seasonKey}
            onChange={() => this.handleChangeRadio(seasonKey)}
            />
            </FormField>
            
            </div>
            ))}
            </Form>

            
            </td> 
            </tr>
            <tr>
            </tr>
            </tbody>
            </table>
            
            </td>
            <td>&nbsp;</td>
            </tr>
            <tr>
            <td>
            <div className="pb2 tc">
            </div>
            </td>
            </tr>
            </tbody>

            </table>
            <table>
            <colgroup>
            <col width="50%" />
            <col width="50%" />
            </colgroup>
            <tbody>
            <tr className="tc">
            <td className="tc">
            <Link to={{
            pathname: `/logout`,
            search  : this.props.location.search
            }}>
            <Button style={{maxWidth:"160px"}}>
            {translate( "Zurück zur Anmeldung" )}
            <i className="icon-angle-right"/>
            </Button>
            </Link>
            </td>
            <td className="tc">
            {(this.state.seasonActive && !this.state.newSeason.season.returnActive) && <Link to={{
            pathname: `/return/quantity`,
            search  : this.props.location.search
            }}>
            <Button style={{maxWidth:"160px"}} disabled={loadingSeason}
            onClick={async () => {
                const checkSeasonName = await shop.cart.getExtra("seasonName")
                if(checkSeasonName == ""){
                    console.log("CHECK SEASON NAME", checkSeasonName)
                    await shop.cart.setExtra("seasonName", this.state.newSeason.season.name)
                    await shop.cart.setExtra("seasonID", this.state.newSeason.season.id)
                }
            }}
            primary >
            {translate( "Zur Paketanmeldung" )}
            <i className="icon-angle-right"/>
            </Button>
            </Link>}
            </td>
            </tr>
            </tbody>
            </table>
            </div>
            { <Message className="pt3 f2 fw7">
                {translate( `Hier können Sie Ihre bereits getätigten Retouren einsehen und noch einmal als PDF anzeigen lassen.`)}
            </Message>}
            <table>
                <colgroup>
                <col width="25%" />
                <col width="75%" />
                </colgroup>
                <tbody>
            {Object.keys(this.state.inventoryOrders).some(key => key.startsWith(this.state.newSeason.season.name)) && <Fragment>
            {console.log("INVENTORY ORDER",this.state.inventoryOrders)}
            {Object.keys(this.state.inventoryOrders).filter(key => key.startsWith(this.state.newSeason.season.name)).map(key => (
                <Fragment key={key}>
                <tr  className="pa3">                   
                        <td>Retourennummer</td>
                        <td className="tr">{this.state.inventoryOrders[key].map_id}</td>
                    </tr>
                    <tr  className="pa3">                   
                        <td>Saison</td>
                        <td className="tr">{this.state.inventoryOrders[key].extras.seasonName}</td>
                    </tr>
                    <tr  className="pa3">                   
                        <td>Packstückmenge</td>
                        <td className="tr">{this.state.inventoryOrders[key].extras.kartons_all}</td>
                    </tr>
                    <tr  className="pa3 bb b--black-50">                   
                        <td>Barcode</td>
                        <td className="tr">{ <Button className="pb2" basic onClick={()=> (this.handleCreatePDF(this.state.inventoryOrders[key]))}>PDF anzeigen</Button>}</td>
                    </tr>
                    </Fragment>
            ))}
            </Fragment>}
            </tbody>
            </table>
            </Responsive>
            </Fragment>
        );
    }
}

export default ReturnPage;


// WEBPACK FOOTER //
// ./src/theme/braunsheitmann/pages/returnCheckout/ReturnPage.js